import styled from 'styled-components';

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 25px;
  padding: 20px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const MainActionsRow = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;

  .actions-left {
    display: flex;
    gap: 16px;
    align-items: center;
    flex: 1;
    .action-button {
      max-height: 38px;
      max-width: 120px;
      font-size: 12px;
      color: #212529;
      font-style: normal;
      line-height: normal;
    }
  }

  .create-lead-btn {
    height: 38px;
    font-size: 14px;
    font-weight: 600;
    margin-left: auto;
  }

  @media (max-width: 768px) {
    .create-lead-btn {
      margin-left: 0;
      width: 100%;
    }
  }
`;

export const FilterRow = styled.div`
  > div {
    > div > div {
      min-height: auto;
      > div > div {
        min-height: 38px;
      }
    }
  }
`;
export const FilterRowLine = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-end;
  flex-wrap: wrap;
  width: 100%;
  > div {
    min-height: 0;
    width: 200px;
  }

  @media (max-width: 768px) {
    gap: 12px 10px;
    > div {
      width: calc(50% - 10px);
    }
    .date-group {
      width: 100%;
    }
  }
  @media (max-width: 480px) {
    > div {
      width: 100%;
    }
    .date-inputs {
      flex-direction: column;
      > div {
        width: 100%;
      }
    }
  }
`;

export const DateRangeGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: auto !important;
  min-width: auto !important;

  .date-inputs {
    display: flex;
    gap: 8px;
    align-items: center;
  }
`;

export const FilterLabel = styled.label`
  color: #6c757d;
  font-weight: 700;
  margin-bottom: 4px;
  display: block;
  font-size: 12px;
`;

export const InputWrapper = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  width: 100%;
  > div {
    min-height: 38px;
    label {
      color: #6c757d;
      font-weight: 700;
      font-size: 12px;
    }
  }

  .search-inputs {
    width: 304px;
  }
  @media (max-width: 707px) {
    &.change-status {
      > div {
        flex: 0;
      }
    }
    > div {
      flex: 1 1 100%;
      max-width: none;
    }

    .search-inputs {
      max-width: none;
      width: 100%;
    }
  }
  @media (max-width: 430px) {
    &.change-status {
      width: 100%;
      > div {
        width: 100%;
        flex: 1;
      }
    }
  }
`;

export const Line = styled.div`
  border-top: 1px solid #dfdfdf;
  padding: 10px 0;
  width: 100%;
`;

export const ClearAllRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

export const ClearAllText = styled.span`
  cursor: pointer;
  color: #212529;
  font-size: 14px;
  font-weight: 600;
  width: 57px;
  text-decoration: underline;
`;

export const CloseIconWrapper = styled.div`
  cursor: pointer;
  height: 15px;
`;

export const Icon = styled.img`
  width: 14px;
  height: 14px;
`;

export const SortButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid #2b7fff;
  background: #eff6ff;
  height: 38px;
  font-size: 12px;
  color: #1447e6;
  cursor: pointer;
  font-weight: 500;
  gap: 8px;

  span {
    font-weight: 400;
    margin-left: 10px;
  }
`;
export const BadgeItemStatus = styled.div`
  height: 24px;
  min-width: 82px;
  border-radius: 22px;
  background: #15c7a71a;
  font-family: Nunito;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0px;
  color: #15c7a7;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  box-shadow:
    0px 1px 2px -1px #0000001a,
    0px 1px 3px 0px #0000001a;

  &.reassign {
    background: #fff0e5;
    color: #ff6a00;
  }
`;
export const CardRightIcon = styled.img``;
export const OptionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 2px 0;
`;

export const StatusDot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
`;

export const OptionLabel = styled.span`
  color: #212529;
  font-size: 14px;
`;

export const MenuHeader = styled.div`
  padding: 8px 12px 4px;
  color: #64748e;
  font-size: 12px;
  font-weight: 600;
`;

export const HiddenFileInput = styled.input`
  display: none;
`;

export const CustomDatePickerWrapper = styled.div`
  width: 173px;
`;

export const FilterClearRow = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
`;

export const BulkActionsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const AssignButton = styled.button`
  height: 28px;
  padding: 0 16px;
  background: #15c7a71a;
  color: #15c7a7;
  border: none;
  border-radius: 22px;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  cursor: pointer;
  box-shadow:
    0px 1px 2px -1px #0000001a,
    0px 1px 3px 0px #0000001a;
  transition: all 0.2s ease;

  &:hover {
    opacity: 0.85;
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
    transform: none;
  }
`;

export const ReAssignButton = styled.button`
  height: 28px;
  padding: 0 16px;
  background: #fff0e5;
  color: #ff6a00;
  border: none;
  border-radius: 22px;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  cursor: pointer;
  box-shadow:
    0px 1px 2px -1px #0000001a,
    0px 1px 3px 0px #0000001a;
  transition: all 0.2s ease;

  &:hover {
    opacity: 0.85;
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
    transform: none;
  }
`;

export const TakeLeadButton = styled.button`
  height: 28px;
  padding: 0 16px;
  background: linear-gradient(90deg, #2768cb 31.73%, #224f91 100%);
  color: #ffffff;
  border: none;
  border-radius: 22px;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  cursor: pointer;
  box-shadow:
    0px 1px 2px -1px #0000001a,
    0px 1px 3px 0px #0000001a;
  transition: all 0.2s ease;

  &:hover {
    opacity: 0.85;
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
    transform: none;
  }
`;
